import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
// import { connect, useDispatch } from "react-redux";
import { Col, Row, Container } from "react-bootstrap";
// import { AGENCY_REGISTER_FAIL, AGENCY_REGISTER_SUCCESS, agencyRegisterAction, submitForm } from './redux/actions/actions';
import { useTranslation } from "react-i18next";

const { config } = require("./api/api");

const CreateAgencyStaff = () => {
  const { t } = useTranslation();

    const [formData,setFormData]=useState({ firstname:"",lastname:"",email:"", password:"" ,confirmpassword:""});
    const [errors,setErrors]=useState({});

    const firstnameRef=useRef(null);
    const lastnameRef=useRef(null);
    const emailRef=useRef(null);
    const passwordRef=useRef(null);
    const confirmpasswordRef=useRef(null);



    const handleChange = (e) => {
    const { name, value } = e.target;
    const trimValue = value.trimStart();

    
    const nameRegex = /^[A-Za-z\s]*$/;
      
    

    if (name === "firstname" || name === "lastname") {
      if (nameRegex.test(trimValue)) {
        setFormData({ ...formData, [name]: trimValue });
      }
    }
 
    else {
      setFormData({ ...formData, [name]: trimValue });
    }
  };


    const handleValidation = () => {
  let newErrors = {};

if(!formData.firstname){
     newErrors.firstname = "First Name  Required";
}
if(!formData.lastname){
     newErrors.lastname = "Last Name  Required";
}
  if (!formData.email?.trim()) {
    newErrors.email = "Email Required";
  } else{
 const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email format";
    
  }
  }
   
  if(!formData.password){
     newErrors.password = "Password  Required";
}
 if(!formData.confirmpassword){
     newErrors.confirmpassword = "Confirm Password  Required";
}else{
if(formData.password !== formData.confirmpassword){
    newErrors.confirmpassword = "Confirm Password not match";
}
}




  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    const firstError = Object.keys(newErrors)[0];
    switch (firstError) {
         case "firstname":
        firstnameRef.current.focus();
        break;
      case "lastname":
        lastnameRef.current.focus();
        break;
      case "email":
       emailRef.current.focus();
        break;
        case "password":
        passwordRef.current.focus();
        break;
        case "confirmpassword":
        confirmpasswordRef.current.focus();
        break;
    }
    return false;
  }

  return Object.keys(newErrors).length===0 ;
};



    
   const handleBlur=(e)=>{
    const { name } =e.target;
    if(formData[name]?.trim()){
setErrors((prev)=>({...prev,[name]:""}))
    }
    
   }

const handleSubmit=(e)=>{
     e.preventDefault(); 
  if( handleValidation()){
    console.log(formData,"test")
  }
}

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [cpasswordVisible, setcPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const togglecPasswordVisibility = () => {
    setcPasswordVisible(!cpasswordVisible);
  };

  const [loading, setLoading] = useState(false);

  return (
    <Fragment>
    <div className="header_section1">
 
         <Navbar />
 
 
         <div className="container-fluid bg-breadcrumb">
           <div className="container text-center py-5" >
             <h3 className="abt-txt my-5" >{t("Create Agency Staff")}</h3>
           </div>
         </div>
 
 
       </div>

      <div className="features_section layout_padding my-3">
        <div className="container">
          <div className="row">
            <Col md={3}></Col>

            <Col md={6} className="myforms">
              

              <form>
                <div className="input-group mb-2 mt-2">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      {t("First")} {t("Name")}
                    </span>
                  </div>
                  <input
                    type="text"
                    name="firstname"
                    ref={firstnameRef}
                    className="form-control"
                     value={formData?.firstname}
                     onChange={handleChange}
                     onBlur={handleBlur}
                    
                  />
                
                </div>
 {errors.firstname && <span style={{color:"red"}}>{errors.firstname}</span>}
                <div className="input-group mb-2 ">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      {t("Last")} {t("Name")}
                    </span>
                  </div>
                  <input
                    type="text"
                    name="lastname"
                    ref={lastnameRef}
                    className="form-control"
                     value={formData?.lastname}
                     onChange={handleChange}
                     onBlur={handleBlur}
                    
                  />
                   
                </div>
{errors.lastname && <span style={{color:"red"}}>{errors.lastname}</span>}

                <div className="input-group mb-2 ">
                  <div className="input-group-prepend">
                    <span className="input-group-text">{t("Email")}</span>
                  </div>
                  <input
                    type="email"
                    name="email"
                    ref={emailRef}
                    className="form-control"
                     value={formData?.email}
                     onChange={handleChange}
                     onBlur={handleBlur}
                   
                  />
                  
                </div>
 {errors.email && <span style={{color:"red"}}>{errors.email}</span>}
                <div className="input-group mb-2 ">
                  <div className="input-group-prepend">
                    <span className="input-group-text">{t("Password")}</span>
                  </div>
                  <input
                    type={passwordVisible ? "text" : "password"}
                    name="password"
                    ref={passwordRef}
                    className="form-control"
                     value={formData?.password}
                     onChange={handleChange}
                     onBlur={handleBlur}
                    
                  />
                  <div className="input-group-append">
                    <button
                      type="button"
                      className="btn btn-outline-grey"
                      onClick={togglePasswordVisibility}
                    >
                      {passwordVisible ? (
                        <i className="fas fa-eye"></i>
                      ) : (
                        <i className="fas fa-eye-slash"></i>
                      )}
                    </button>
                  </div>
                  
                </div>
 {errors.password && <span style={{color:"red"}}>{errors.password}</span>}
                <div className="input-group mb-2 ">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      {t("Confirm")} {t("Password")}
                    </span>
                  </div>
                  <input
                    type={cpasswordVisible ? "text" : "password"}
                    name="confirmpassword"
                    className="form-control"
                    ref={confirmpasswordRef}
                     value={formData?.confirmpassword}
                     onChange={handleChange}
                     onBlur={handleBlur}
                
                  />
                  <div className="input-group-append">
                    <button
                      type="button"
                      className="btn btn-outline-grey"
                      onClick={togglecPasswordVisibility}
                    >
                      {cpasswordVisible ? (
                        <i className="fas fa-eye"></i>
                      ) : (
                        <i className="fas fa-eye-slash"></i>
                      )}
                    </button>
                  </div>
                  
                </div>
{errors.confirmpassword && <span style={{color:"red"}}>{errors.confirmpassword}</span>}

<div className=" mt-2">
    <button
                  className="btn btn-primary rounded-pill text-white my-2 py-1 px-4 "
                  onClick={handleSubmit}
                >
                  {t("Submit")}
                </button>
</div>
                
              </form>
            </Col>

            <Col md={3}></Col>
          </div>
        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </Fragment>
  );
};

export default CreateAgencyStaff;
